{
  "notFound": "We couldn't find this questionnaire.",
  "landing": {
    "title": "{{tenantName}} has invited you to complete a profile questionnaire",
    "intro": "The questionnaire takes about 15 minutes: 30 short topics, each answered with ten sliders.",
    "autosave": "Your answers are saved as you go, so you can leave and pick up where you left off at any time.",
    "privacyNotice": "Privacy notice: your answers are processed to produce your profile and its evaluation for {{tenantName}}. [TODO: final GDPR privacy-notice copy]",
    "begin": "Begin",
    "reuseHint": "You completed this questionnaire on {{date}}.",
    "reuse": "Use my previous answers",
    "startFresh": "Start fresh"
  },
  "name": {
    "title": "Your name",
    "description": "Your evaluation will address you by this name.",
    "continue": "Continue"
  },
  "progress": {
    "question": "Question {{current}} of {{total}}"
  },
  "swap": {
    "label": "Topic",
    "confirmTitle": "Change topic?",
    "confirmDescription": "Changing the topic discards the answers you've given on this page.",
    "confirm": "Change topic",
    "cancel": "Keep this topic"
  },
  "navigation": {
    "previous": "Previous",
    "next": "Next"
  },
  "review": {
    "title": "Ready to submit?",
    "finalAnswer": "This is your final answer. You won't be able to edit after this.",
    "back": "Back",
    "submit": "Submit"
  },
  "confirmation": {
    "title": "Thank you!",
    "body": "Your answers have been submitted. We'll email you when your evaluation is ready.",
    "cta": "Go to My Profiles"
  },
  "revoked": {
    "title": "This invitation is no longer active",
    "body": "The workspace that sent it has since withdrawn the invitation. If you think this is a mistake, please get in touch with the person who invited you.",
    "cta": "Go to My Profiles"
  }
}
